// @ts-strict-ignore
import React from 'react';
import { ValidatingFormComponent } from '@/hybrid/formbuilder/formBuilder.module';
import moment from 'moment-timezone';
import { Field, useForm } from 'react-final-form';
import { getFormFieldProps, getValidationFunction } from '@/hybrid/formbuilder/formbuilder.utilities';
import { Timezone } from '@/datetime/timezone.service';
import { useShowError } from '@/hybrid/formbuilder/hooks/useShowError';
import { DateTimeEntry } from '@/hybrid/core/DateTimeEntry.atom';
import { FormFieldWrapper } from '@/hybrid/formbuilder/FormFieldWrapper';

export interface DateTimeEntryIF extends ValidatingFormComponent<moment> {
  component: 'DateTimeEntryFormComponent';
  hideTimezone?: boolean;
  fieldIdentifier?: string;
  timezone: Timezone;
  trackCategory?: string;
  trackAction?: string;
  trackInformation?: string;
  dateFormat?: string;
}

export const DateTimeEntryFormComponent: React.FunctionComponent<DateTimeEntryIF> = (props) => {
  const {
    label,
    name,
    testId = 'dateTimeEntry',
    extraClassNames,
    hideTimezone,
    fieldIdentifier,
    timezone,
    customErrorText,
    extendValidation,
    validation,
    trackCategory,
    trackAction,
    trackInformation,
    dateFormat,
  } = props;

  const formState = useForm().getState();
  const { showError, setShowError } = useShowError(false);

  const defaultValidation = (value: moment) => !value;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const { value, showError, onChange } = getFormFieldProps(formState, input, meta, props);
          setShowError(showError);

          return (
            <DateTimeEntry
              testId={`${testId}Field`}
              extraClassName="specRange specRangeStart width-115"
              textExtraClassNames="sq-text-primary flexRowContainer"
              date={value}
              updateDate={onChange}
              dateFormat={dateFormat}
              timezone={timezone}
              inputExtraClassNames="width-100"
              hideTimezone={hideTimezone}
              fieldIdentifier={fieldIdentifier}
              trackCategory={trackCategory}
              trackAction={trackAction}
              trackInformation={trackInformation}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
